import React from "react";

export default function FeatureIconsSection({ features = [] }) {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 text-center">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col items-center">
              <div className="w-20 h-20 flex items-center justify-center rounded-full bg-gray-100 mb-3">
                <img
                  src={feature.icon}
                  alt={feature.title}
                  width={80}
                  height={80}
                  loading="lazy"
                  decoding="async"
                  className="w-20 h-20 object-contain"
                />
              </div>
              <p className="font-medium text-gray-800 text-sm sm:text-base">
                {feature.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
